/* tslint:disable:typedef-whitespace no-trailing-whitespace no-inferrable-types import-spacing */

import { ElementRef }          from '@angular/core';

import { Dialog }              from './dialog';
import { Logger }              from '@/util/logger';
import { Project }             from '@/models/project';
import {
  ProjectType,
  projectTypeOfString
}                              from "@/models/project.type";
import { ProjectFactory     }  from '@/models/project.factory';
import { ServiceManager     }  from "@/services/service.manager";
import { IValidatorCallBack }  from './i.validator.call.back';
import { IOkCallBack        }  from './i.ok.call.back';

import * as $                  from 'jquery';
import 'jquery-ui-dist/jquery-ui';




/**
 *
 * @class NewProjectDialog
 *
 * @brief dialog for creating a new project
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class NewProjectDialog extends Dialog {

  /* the selected type of project */
  private projectType: ProjectType = ProjectType.BatchSimulation;

  /* the selected project name */
  private projectName: string = '';

  /** standard constructor, allow for partial alert to be given */
  constructor(
    host:                ElementRef,
    private services:    ServiceManager,
  ) {

    super(host);

    this.title = 'New Project';
    this.icon  = '<i class="fas fa-plus"></i>';

    Logger.debug('[NewProjectDialog] setting up...');
  }

  /** dialog has been opened */
  public open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    Logger.debug('[NewProjectDialog] opening...');

    this.projectType = ProjectType.BatchSimulation;
    this.projectName = '';

    const body = $(this.host).find('.modal-body');

    const html = `

<div class="control gui-radio-toolbar">

  <input id="batchsimulation"  type="radio" name="type" value="batch_simulation" checked>
  <label for="batchsimulation" class="radio" style="margin-right: 12px;">
    <i class="fas fa-cubes"></i> Simulation
  </label>

  <!--
  <input id="simulation" type="radio" name="type"  value="simulation">
  <label for="simulation" class="radio" style="margin-right: 12px;">
    <i class="fas fa-cube"></i> Simulaton
  </label>
  -->

  <input id="library" type="radio" name="type"  disabled value="library">
  <label for="library" class="radio" style="color: dimgrey;">
    <i class="fas fa-toolbox"></i> Library
  </label>

</div>

<div style="margin-top: 12px;">
<label class="gui-label">Name:</label>
<input class="gui-input project-name-input" type="text" placeholder="Project Name">
</div>
    `;

    $(body).html(html);

    /* add behaviors */

    setTimeout(() => {

      $('input[type=radio][name=type]').on('input', (e) => {

        this.projectType = projectTypeOfString($(e.currentTarget).val() as string);

        this.validate();
      });

      $(this.host).find('.project-name-input').focus();

      $(this.host).find('.project-name-input').on('input', (e) => {

        this.projectName = $(e.currentTarget).val() as string;

        this.validate();
      });

      $(this.host).find('.project-name-input').on('keypress', (e) => {

        if (e.key.toLowerCase() === 'enter') {

          if (this.validate()) {

            /* click the ok button for them, and trigger via ModelComponent */

            const ok = $(this.host).find('.modal-ok-button');

            $(ok).click();

          }

          return false;
        }

      });

    }, 50);

    /* disable the Ok button...until we have valid input */

    this.validate();
  }

  /* don't enable the Ok button until we have what we need. */
  validate(): boolean {

    /* assume its bad */

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).attr('disabled', 'true');
    $(ok).addClass('disabled');

    if (this.projectType === ProjectType.None) {

      return false;
    }

    if (this.projectName === '') {

      return false;
    }

    $(ok).removeAttr('disabled');
    $(ok).removeClass('disabled');

    return true;
  }

  /** dialog is closing */
  public close() {

    Logger.debug('[NewProjectDialog] closing...');
  }

  /** dialog was accepted */
  public ok() {

    Logger.debug('[NewProjectDialog] accepted: ', this.projectType, this.projectName);

    const project: Project = ProjectFactory.fromType(this.projectType, this.projectName) as Project;

    this.services.projects.newProject(project);
  }
}


